/**
 * ClcLeaseSection — CLC Lease Owner Payout label and tooltip copy for BookingDetailModal
 *
 * Charter: documentation/cursor/Charters/CodeAuditor.md v1.0.1
 * Phase 3d extracted from BookingDetailModal.jsx; JSX and strings unchanged.
 *
 * Purpose:
 *   Render CLC Lease folio label content ("Paid to Owner" with optional payoutLabel
 *   parenthetical) and provide tooltip copy for the CLC Lease payout info icon.
 *   Presentational only; parent passes theme, hostPayout; parent owns predicate flags and tooltip show/hide.
 *
 * Assumptions & Invariants:
 *   - Presentational; no fetch; no admin imports.
 *   - getClcLeasePayoutTooltipText is pure: same inputs → same string. Call only when isCLCLease is true.
 *
 * Dependencies: React only
 *
 * Version: 1.0.0
 *
 * Changelog:
 *   2026-01-27 Phase 3d extraction from BookingDetailModal (CLC Lease label + tooltip helper).
 */

const labelSubtextStyle = {
  fontSize: '12px',
  fontStyle: 'italic',
  opacity: 0.8,
  marginLeft: '4px',
};

/**
 * Returns CLC Lease tooltip string for Owner Payout info icon.
 * Same string for final and provisional in current modal.
 * @param {boolean} _isFinalCopy — reserved for API parity; not used (string is identical).
 * @param {boolean} isCLCLease
 * @returns {string | null}
 */
export function getClcLeasePayoutTooltipText(_isFinalCopy, isCLCLease) {
  if (isCLCLease) {
    return 'CLC Lease: Taxes collected for the stay are included in the Owner Payout, and must be remitted by the owner. The damage/security deposit is tracked separately, held in trust, and is not part of the payout or owner revenue.';
  }
  return null;
}

/**
 * Renders CLC Lease Owner Payout label content ("Paid to Owner" + optional payoutLabel).
 * @param {{ theme?: string, hostPayout?: { payoutLabel?: string } }}
 */
export default function ClcLeaseSection({ theme, hostPayout }) {
  if (hostPayout?.payoutLabel) {
    return (
      <>
        Paid to Owner
        <span style={labelSubtextStyle}>
          ({hostPayout.payoutLabel})
        </span>
      </>
    );
  }
  return 'Paid to Owner';
}
